import React, { Component } from 'react';
import { Button, Col, Row, Container, CardBody, Card } from 'reactstrap';
import axiosInstance from '@src/axios-instance';
import { withRouter } from 'react-router';

class UploadUnits extends Component {
  openFilePicker = () => {
    this.fileUpload.click();
  };

  onFileSelect = e => {
    if (this.fileUpload.files.length > 0) {
      const formData = new FormData();
      formData.append('file', this.fileUpload.files[0]);

      axiosInstance()
        .post(`/associations/upload-units/${this.props.id}.json`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          localStorage.setItem(
            'associationFlash',
            'New units successfully uploaded.'
          );
          this.props.history.push(`/associations/${this.props.id}`);
        })
        .catch(err => {});
      this.fileUpload.value = '';
    }
  };

  render = () => {
    return (
      <Container>
        <Row>
          <Col>
            <Card>
              <CardBody>
                <div className={'pb-3'}>
                  <h3>
                    Upload Units
                    <Button
                      color={'secondary'}
                      className={'float-right'}
                      size={'sm'}
                      onClick={this.openFilePicker}
                    >
                      Upload New
                    </Button>
                    <input
                      ref={ref => (this.fileUpload = ref)}
                      type={'file'}
                      className={'d-none'}
                      onChange={this.onFileSelect}
                      accept={'.csv'}
                    />
                  </h3>
                  <p>Supported file formats: csv</p>
                  <p>
                    <i>
                      Duplicate addresses will be removed. Please make sure the
                      CSV file format is correct. See below for the list of
                      recoganized table columns:
                      <ul>
                        <li>Phase_No</li>
                        <li>Address_No</li>
                        <li>Unit_No</li>
                        <li>Street (Required)</li>
                        <li>City (Required)</li>
                        <li>State (Required)</li>
                        <li>Zip Code (Required)</li>
                        <li>Owner</li>
                        <li>Second_Owner</li>
                        <li>Vesting1</li>
                        <li>Third_Owner</li>
                        <li>Fourth_Owner</li>
                        <li>Vesting2</li>
                      </ul>
                    </i>
                  </p>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  };
}
export default withRouter(UploadUnits);
